import { combineReducers } from "redux";
import list from "./list";
import create from "./create";
import attach from "./attach";
import update from "./update";
import del from "./delete";
import show from "./show";

export default combineReducers({ list, create, attach, update, del, show });
